import {useDispatch, useSelector} from "react-redux";
import {leftMenuOpenedSelector, toggle} from "@/components/Menu/LeftMenu/Slice/UILeftMenuSlice";
import {Link as RouterLink} from "react-router-dom";
import Link from '@mui/material/Link';
import UrlsConfig from "@/config/UrlsConfig";
import {Drawer} from "@mui/material";
import Divider from '@mui/material/Divider';
import Logo from "@/components/Logo/Logo";
import styles from "./styles/LeftMenu.module.scss";
import {useWindowSize} from "@/hooks/useWindowSize";
import {useGetCurrentUserMenuQuery} from "@/api/Settings/MenuSettings/CurrentUserMenu/GetCurrentUserMenuApiSlice";
import LeftMenuItem from "@/components/Menu/LeftMenu/LeftMenuItem";
import { notAuthenticatedUserId, userSelector } from "@/features/Auth/CurrentUser/Slice/CurrentUserSlice";
import {appRoles, doesUserRolesMatchRequired} from "@/common/appRoles";
import {useGetCountWaitingVisitDateQuery} from "@/api/Orders/CountWaitingVisitDate/CountWaitingVisitDate";
import usePageFocused from "@/hooks/usePageFocused";
import {isLabUserEmail} from "@/common/isLabUser";

export const desktopLeftMenuWidth = 240;
export const minWidthForDesktopLeftMenu = 1100;

const LeftMenu = () => {

    const urlsConfig = new UrlsConfig();

    const dispatch = useDispatch();

    const opened = useSelector(leftMenuOpenedSelector);
    const user = useSelector(userSelector);
    const isShortened = user.is_shortened === true;

    const isManager = doesUserRolesMatchRequired({
        suitableRoles: [appRoles.manager.alias],
        userRoles: user.roles.map(role => role.alias),
    });

    const isPartner = doesUserRolesMatchRequired({
        suitableRoles: [appRoles.partner.alias],
        userRoles: user.roles.map(role => role.alias),
    });

    const size = useWindowSize();
    const windowWidth = size.width ?? 0;
    const isPageFocused = usePageFocused();

    const drawerVariant = windowWidth > minWidthForDesktopLeftMenu ? "persistent" : "temporary";

    const {data} = useGetCurrentUserMenuQuery(undefined, {
        skip: user.id === notAuthenticatedUserId,
        refetchOnMountOrArgChange: true,
    });
    const {data: countData} = useGetCountWaitingVisitDateQuery(undefined, {
        skip: !isPartner,
        pollingInterval: isPageFocused ? 3 * 60 * 1000 : 0,
    });

    const menu = data?.data || [];
    const isLabUser = isLabUserEmail(user.email);
    const visibleMenu = isLabUser ? menu.filter(({alias}) => alias !== "create-new-order") : menu;
    const countWaitingVisitDate = countData?.count ?? 0;


    return (
      <div>
          <Drawer
            sx={{
                width: desktopLeftMenuWidth,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: desktopLeftMenuWidth,
                    boxSizing: 'border-box',
                    overflowY: 'auto',
                },
            }}
            open={opened}
            variant={drawerVariant}
            anchor="left"
            onClose={() => {
                dispatch(toggle());
            }}
          >

              <div className={styles.header}>
                  <Link
                    component={RouterLink}
                    underline="none"
                    to={urlsConfig.index.to}
                    sx={{height: "65%"}}
                  >
                      <Logo classes={styles.logo}/>
                  </Link>
              </div>

              <Divider/>

              {visibleMenu.map((menuItem) => (
                <LeftMenuItem
                  key={menuItem.id}
                  to={menuItem.url}
                  title={isShortened && ["orders", "allorders", "myorders", "orders-and-appointments"].includes(menuItem.alias) ? "Заказы" : menuItem.title}
                  alias={menuItem.alias}
                  isNewWindow={menuItem.is_new_window === 1}
                  children={menuItem?.children}
                  isManager={isManager}
                  badgeCount={menuItem.alias === "confirmation-requests" ? countWaitingVisitDate : 0}
                />
              ))}

          </Drawer>
      </div>
    )
};


export default LeftMenu;
